var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-xl":""}},[_vm._v("\n  "+_vm._s(_vm.adminText('workflowsAll.promote_container_4483e75', 'PROMOTE CONTAINER'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }